import React, {useState, useEffect}  from "react";
import { db } from '../../../firebase/firebaseConfig';
import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { collection, onSnapshot, deleteDoc, doc } from 'firebase/firestore';
import Alerta from "../../../components/Alerta";
import { getStorage, ref, deleteObject } from "firebase/storage";

const ListaInfoInicio = ({ onEditar }) => {
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [infoInicio, setInfoInicio] = useState([]);

    // Función para truncar el texto
    const truncateText = (text, maxLength = 100) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

    useEffect(() => {
        onSnapshot(collection(db, 'infoiniciocalocho'),
            (snapshot) => {
                const arregloInfoInicio = snapshot.docs.map((docInfoInicio) => {
                    return {...docInfoInicio.data(), id: docInfoInicio.id};
                })

                setInfoInicio(arregloInfoInicio);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    const handleEditar = (id) => {
        onEditar(id);
        console.log(id);
    }

    const handleEliminarInfoInicio = async(id, urlImagen) => {
        console.log('Estoy aquí handleEliminarInfoInicio');
        try {
            await deleteDoc(doc(db, 'infoiniciocalocho', id));
            console.log('Estoy aquí handleEliminarInfoInicio try deleteDoc');
            // Crear una referencia al objeto de la imagen en Firebase Storage y eliminarlo
            const storageRef = getStorage();
            console.log('Estoy aquí handleEliminarInfoInicio try storageRef ' + storageRef);
            const fileRef = ref(storageRef, urlImagen);
            console.log('Estoy aquí handleEliminarInfoInicio try fileRef ' + fileRef);

            await deleteObject(fileRef).then(() => {
                console.log('Imagen eliminada con éxito');
                setEstadoAlerta(true);
                setAlerta({tipo: 'exito', mensaje: 'Imagen eliminada con éxito'});
            }).catch((error) => {
                console.error('Error al eliminar la imagen:', error);
                setEstadoAlerta(true);
                setAlerta({tipo: 'error', mensaje: 'Error al eliminar la imagen'});
            });

            setEstadoAlerta(true);
            setAlerta({tipo: 'exito', mensaje: 'Se eliminaron los datos correctamente'});
        } catch (error) {
            console.log(error);
            setEstadoAlerta(true);
            setAlerta({tipo: 'error', mensaje: 'Hubo un error al eliminar el infoinicio'});
        }
    }
    
    return(
        infoInicio.length > 0 &&
        <Grid 
            item 
            xs={12}  // Ocupa todo el ancho en pantallas pequeñas
        >
            <Paper sx={{ 
                p: 2, 
                display: 'flex', 
                flexDirection: 'column', 
                boxShadow: 3, 
                borderRadius: 2, 
                overflowX: 'auto',  // Añadir scroll horizontal si es necesario
                '@media (max-width: 600px)': {  // Pantallas más pequeñas
                    padding: 1,  // Reducir el padding en móviles
                },
            }}>
                <Typography variant='h5' sx={{ 
                    width: 'auto',
                    textAlign: 'center', 
                    '@media (max-width: 600px)': {  // Ajustar el tamaño de fuente en pantallas pequeñas
                    fontSize: '1.25rem',
                    },
                }}>Lista de la nueva información</Typography>
                <div style={{ overflowX: 'auto', maxHeight: '250px', overflowY: 'auto', scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }}>
                    <Table size="small" sx={{ 
                        width: '100%', 
                        minWidth: '300px',  // Mantener un tamaño mínimo
                        '@media (max-width: 600px)': {  // Pantallas móviles
                            minWidth: 'auto',  // Hacer que se ajuste en pantallas pequeñas
                        },
                    }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ 
                                    position: 'sticky', 
                                    top: 0, 
                                    backgroundColor: 'white', 
                                    zIndex: 1, 
                                    width: '30%',  // Ajustar ancho relativo
                                    '@media (max-width: 600px)': { 
                                        fontSize: '0.75rem',  // Reducir el tamaño del texto en móviles
                                    },
                                }}>Título</TableCell>
                                <TableCell sx={{ 
                                    position: 'sticky', 
                                    top: 0, 
                                    backgroundColor: 'white', 
                                    zIndex: 1, 
                                    width: '50%',  // Ajustar ancho relativo
                                    '@media (max-width: 600px)': { 
                                    fontSize: '0.75rem',  // Reducir el tamaño del texto en móviles
                                    },
                                }}>Subtitulo</TableCell>
                                <TableCell sx={{ 
                                    position: 'sticky', 
                                    top: 0, 
                                    backgroundColor: 'white', 
                                    zIndex: 1, 
                                    width: '10%',  // Reducir el tamaño en pantallas pequeñas
                                }}>Editar</TableCell>
                                <TableCell sx={{ 
                                    position: 'sticky', 
                                    top: 0, 
                                    backgroundColor: 'white', 
                                    zIndex: 1, 
                                    width: '10%', 
                                }}>Eliminar</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {infoInicio.map((infoinicio) => (
                                <TableRow key={infoinicio.id}>
                                    <TableCell sx={{ 
                                        textAlign: 'center', 
                                        '@media (max-width: 600px)': { 
                                            fontSize: '0.75rem',  // Ajustar tamaño en móviles
                                        },
                                    }}>{infoinicio.titulo}</TableCell>
                                    <TableCell sx={{ 
                                        textAlign: 'center', 
                                        '@media (max-width: 600px)': { 
                                            fontSize: '0.75rem',  // Ajustar tamaño en móviles
                                        },
                                    }}>{truncateText(infoinicio.subtitulo)}</TableCell>
                                <TableCell sx={{ 
                                    textAlign: 'center'
                                }}>
                                    <EditIcon sx={{
                                        backgroundColor: '#f9f9f9',
                                        color: '#5d0303',
                                        borderRadius: '50%',
                                        width: 30,
                                        height: 30,
                                        '&:hover': {
                                        backgroundColor: '#5d0303',
                                        color: '#fff',
                                        },
                                        '@media (max-width: 600px)': { 
                                        width: 25,  // Tamaño más pequeño en móviles
                                        height: 25,
                                        },
                                    }} onClick={() => handleEditar(infoinicio.id)}/>
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    <DeleteIcon sx={{
                                        backgroundColor: '#f9f9f9',
                                        color: '#5d0303',
                                        borderRadius: '50%',
                                        width: 30,
                                        height: 30,
                                        '&:hover': {
                                        backgroundColor: '#5d0303',
                                        color: '#fff',
                                        },
                                        '@media (max-width: 600px)': { 
                                        width: 25,
                                        height: 25,
                                        },
                                    }} onClick={() => handleEliminarInfoInicio(infoinicio.id, infoinicio.imagen)}/>
                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <Alerta 
                    tipo={alerta.tipo}
                    mensaje={alerta.mensaje}
                    estadoAlerta={estadoAlerta}
                    setAlerta={setEstadoAlerta}
                />
            </Paper>
        </Grid>
    );
}

export default ListaInfoInicio;